import http from '@/communication/AuthConnection'

export default ({ commit, state }, { stockId, selectItem = true }) => {
  const itemId = state.selectedItem._id
  http.post(`/v1/item-association`, { stockId, itemId })
    .then((quotePayload) => {
      state.list.map((item, idx) => {
        if (item._id === quotePayload.data._id) {
          const itemIndex = idx
          const itemData = quotePayload.data
          commit('UPDATE_ITEM', { itemIndex, itemData })
          if (selectItem) commit('SET_SELECTED_ITEM', { itemDetail: itemData })
        }
      })
    })
}



// WEBPACK FOOTER //
// ./src/brain/item-association/QuoteItem.js